import { React, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useGlobalContext } from "../context";
import "./GameSettings.css";
import { GiChessKing } from "react-icons/gi";
import EngineStrengthPicker from "./EngineStrengthPicker";

const GameSettings = () => {
  const {
    piecesColor,
    setPiecesColor,
    setBoardOrientation,
    boardOrientation,
    engineStrength,
    setEngineStrength,
  } = useGlobalContext();
  const [picked, setPicked] = useState("w");

  // set default values
  useEffect(() => {
    setPiecesColor(1);
    setBoardOrientation("white");
    setEngineStrength(1000);
  }, [setPiecesColor, setBoardOrientation, setEngineStrength]);

  // save user pre-game settings
  useEffect(() => {
    localStorage.setItem("piecesColor", piecesColor);
  }, [piecesColor]);

  useEffect(() => {
    localStorage.setItem("boardOrientation", boardOrientation);
  }, [boardOrientation]);

  return (
    <div className="game-settings">
      <h2>Wybierz wariant aby rozpocząć</h2>
      <div className="game-settings-btns">
        <Link to="/play-classic">
          <button className="btn btn-blue">wariant klasyczny</button>
        </Link>
        <Link to="/play-960">
          <button className="btn">wariant 960</button>
        </Link>
      </div>
      <div className="select-options">
        <h4 className="options-text">dostosuj moc silnika</h4>
        <EngineStrengthPicker />
      </div>

      <div className="pick-color">
        <button
          className={`${
            picked === "w"
              ? "btn btn-blue white-icon picked"
              : "btn btn-blue white-icon"
          }`}
          onClick={() => {
            setPicked("w");
            setPiecesColor(1);
            setBoardOrientation("white");
          }}
        >
          <GiChessKing />
        </button>
        <button
          className={`${
            picked === "r"
              ? "btn btn-blue random-icon picked"
              : "btn btn-blue random-icon"
          }`}
          onClick={() => {
            setPicked("r");
            setPiecesColor(Math.floor(Math.random() * 2));
            if (piecesColor) {
              setBoardOrientation("white");
            } else {
              setBoardOrientation("black");
            }
          }}
        >
          <svg width="0" height="0">
            <linearGradient
              id="half-gradient"
              x1="49%"
              y1="0%"
              x2="50%"
              y2="0%"
            >
              <stop stopColor="#000" offset="50%" />
              <stop stopColor="#fff" offset="50%" />
            </linearGradient>
          </svg>
          <GiChessKing style={{ fill: "url(#half-gradient)" }} />
        </button>
        <button
          className={`${
            picked === "b"
              ? "btn btn-blue black-icon picked"
              : "btn btn-blue black-icon"
          }`}
          onClick={() => {
            setPicked("b");
            setPiecesColor(0);
            setBoardOrientation("black");
          }}
        >
          <GiChessKing />
        </button>
      </div>
    </div>
  );
};
export default GameSettings;
